import { mode } from "@chakra-ui/theme-tools";
import { StyleFunctionProps } from "@chakra-ui/react";

interface ComponentStyleObject {
  [key: string]: any;
}

interface TextareaVariant {
  (props: StyleFunctionProps): ComponentStyleObject;
}

interface TextareaConfig {
  components: {
    Textarea: {
      baseStyle: ComponentStyleObject;
      variants: Record<string, TextareaVariant>;
      defaultProps: {
        variant: string;
      };
    };
  };
}

export const textareaStyles: TextareaConfig = {
  components: {
    Textarea: {
      baseStyle: {
        field: {
          fontWeight: 400,
          borderRadius: "8px",
        },
      },

      variants: {
        main: (props: StyleFunctionProps) => ({
          field: {
            bg: mode("transparent", "navy.800")(props),
            border: "1px solid !important",
            color: mode("secondaryGray.900", "white")(props),
            borderColor: mode("secondaryGray.100", "whiteAlpha.100")(props),
            borderRadius: "16px",
            fontSize: "sm",
            p: "20px",
            _placeholder: { color: "secondaryGray.400" },
          },
        }),
        auth: (props: StyleFunctionProps) => ({
          field: {
            bg: "white",
            border: "1px solid",
            borderColor: "secondaryGray.100",
            borderRadius: "16px",
            _placeholder: { color: "secondaryGray.600" },
          },
        }),
        authSecondary: (props: StyleFunctionProps) => ({
          field: {
            bg: "white",
            border: "1px solid",

            borderColor: "secondaryGray.100",
            borderRadius: "16px",
            _placeholder: { color: "secondaryGray.600" },
          },
        }),
        search: (props: StyleFunctionProps) => ({
          field: {
            border: "none",
            py: "11px",
            borderRadius: "inherit",
            _placeholder: { color: "secondaryGray.600" },
          },
        }),
        filled: (props: StyleFunctionProps) => ({
          bg: mode("gray.200", "gray.700")(props),
          _hover: {
            bg: mode("gray.200", "gray.600")(props),
          },
          _focus: {
            borderColor: mode("teal.500", "teal.300")(props),
            boxShadow: `0 0 0 1px ${mode("teal.500", "teal.300")(props)}`,
          },
          _placeholder: {
            color: mode("gray.500", "whiteAlpha.700")(props),
          },
        }),
      },
      defaultProps: {
        variant: "filled",
      },
    },
  },
};
